import React, { useState } from 'react';
import withReactiveStyleBuyButton from '../../Containers/withReactiveStyleBuyButton';
import { post } from '../../Services/http';
import { translate } from '../../Services/translation';
import(`./styles/${global.ThemeName}.scss`);

const LoadMoreButton = (props) => {
  const {
    skip,
    take,
    identifier,
    type,
    onLoaded,
    onClick: loadProducts,
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const onClick = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await loadProducts({ identifier, skip, take, type, onLoaded });
    setIsLoading(false);
  };

  return (
    <button className="btn btn--black" disabled={isLoading} onClick={onClick}>
      {!isLoading && translate('category.loadmore.button')}
      {isLoading && translate('category.loadmore.buttonfetching')}
    </button>
  );
};

const loadMore = async ({ identifier, skip, take, type, onLoaded }) => {
  try {
    const url = new URL(window.location);
    const res = await post(`/api/loadmore/${type}${url.search}`, {
      identifier,
      skip,
      take,
    });

    onLoaded(await res.json());
  } catch {}
};

export default withReactiveStyleBuyButton(
  LoadMoreButton,
  loadMore,
  'btn-state'
);
